import axiosInstance from './axiosInstance';

export const companyApi = {
  getCompanies: (params) => axiosInstance.get('/companies', { params }),
  getCompanyById: (id) => axiosInstance.get(`/companies/${id}`),
  createCompany: (data) => axiosInstance.post('/companies', data),
  updateCompany: (id, data) => axiosInstance.put(`/companies/${id}`, data),
  deleteCompany: (id) => axiosInstance.delete(`/companies/${id}`)
};
